module.exports = __webpack_public_path__ + "img/outputdata-image3.8c08cc0d.png";